// Copyright (c) 2022 by Move Closer

import { ModuleBase, ModuleFactory } from '../../contexts'

import { abstractModuleFactory, getDefaultModuleAlignment } from '../abstract/form'

import { AvailableModuleDriver } from '../allowed'
import { DescriptionListModule, DescriptionListModuleContent } from './DescriptionList.contracts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const descriptionListContentFactory = (): DescriptionListModuleContent => ({
  data: [],
  isCollapsible: false
})

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const descriptionListFactory: ModuleFactory<DescriptionListModule> = {
  ...abstractModuleFactory,
  createModule (): ModuleBase<DescriptionListModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: descriptionListContentFactory(),
      driver: AvailableModuleDriver.DescriptionList
    }
  }
}
